<template>
  <HeaderComp/>
  <router-view/>
  <FooterComp/>
</template>

<script>
// @ is an alias to /src
import HeaderComp from '@/layout/HeaderComp.vue'
import FooterComp from '@/layout/FooterComp.vue'

export default {
  name: 'App',
  components: {
    HeaderComp,
    FooterComp,
  }
}
</script>
